import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const Container = styled.div.attrs(({ setType = "div", ...rest }) => ({
  as: setType,
  ...rest,
}))`
  line-height: 2;
  display: block;
  margin-bottom: 0.6rem;
  width: 100%;
  max-width: 100%;

  ${(props) =>
    props.row &&
    `
      display: flex;
      flex-direction: row;
      align-items: center;
    `
  }

  ${(props) =>
    !props.noBorder &&
    props.text &&
    `
    box-sizing: border-box;
    border-radius: 0.25rem;`}

  .Label_title_p {
    text-align: left;
    margin-bottom: -0.15rem;
    max-width: 100%;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1.8rem;
    color: ${Colors.Color7};
    ${(props) => props.row && `width: 6rem; margin-bottom: 0rem;`}
  }

  ${(props) =>
    !props.noInput &&
    `select, textArea,
      input {
      width: 100%;
      max-width: 100%;
    }`}

  .Label_text {
    text-align: left;
    font-weight: 500;
    text-transform: none;
    height: 2.4rem;
    padding: 0em 0.5rem;
    color: #1e2b3a;
    border: 0.1em solid #e4e4e4;
    background: #ededed;
    border-radius: 0.375rem;
    font-size: 1rem;
    vertical-align: middle;

    color: #fff;
    border-color:  #1f3346;
    background-color: #256172;
  }

  .fullText {
    height: 16.5rem !important;
  }

  .fullTextGeral {
    height: 24rem !important;
  }
`;
